<template>
  <div className="animated">
    <b-card class="animated fadeIn">
      <b-card-body>
        <b-modal
          id="modal-lg"
          ref="infoModal"
          centered
          size="lg"
          title="Detalle de guia de despacho"
          @ok="waybill = null"
          ok-only
        >
          <div class="text-center">
            <b-spinner v-if="!waybill" label="Spinning"></b-spinner>
          </div>
          <report v-if="waybill" :waybill="waybill"></report>
        </b-modal>

        <email-modal
          :to="to"
          :cc="cc"
          :bcc="bcc"
          :waybill_id="waybill_id"
          :type="1"
          :subject="subject"
          :msg="msg"
          ref="email"
        ></email-modal>

        <h1>Guias de despacho (recibidas)</h1>
        <div>
          <b-form>
            <b-row>
              <b-col>
                <label for="monthSelect">Mes</label>
                <b-form-select
                  id="monthSelect"
                  v-model="selected.month"
                  :plain="true"
                  :options="selectOptions.months"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
              <b-col>
                <label for="yearSelect">Año</label>
                <b-form-select
                  id="yearSelect"
                  v-model="selected.year"
                  :plain="true"
                  :options="selectOptions.years"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
              <!--              <b-col>-->
              <!--                <label for="productSelect">Seleccione Producto</label>-->
              <!--                <b-form-select-->
              <!--                  id="productSelect"-->
              <!--                  v-model="selected.product"-->
              <!--                  :plain="true"-->
              <!--                  :options="selectOptions.products"-->
              <!--                  value="Seleccione...">-->
              <!--                </b-form-select>-->
              <!--              </b-col>-->
              <!--              <b-col>-->
              <!--                <label for="conditionSelect">Condición</label>-->
              <!--                <b-form-select-->
              <!--                  id="conditionSelect"-->
              <!--                  v-model="selected.condition"-->
              <!--                  :plain="true"-->
              <!--                  :options="selectOptions.conditions"-->
              <!--                  value="Seleccione...">-->
              <!--                </b-form-select>-->
              <!--              </b-col>-->
              <!--              <b-col>-->
              <!--                <label for="productTypeSelect">Tipo de Producto</label>-->
              <!--                <b-form-select-->
              <!--                  @change="getProductSet"-->
              <!--                  id="productTypeSelect"-->
              <!--                  v-model="selected.product_type"-->
              <!--                  :plain="true"-->
              <!--                  :options="selectOptions.product_types"-->
              <!--                  value="Seleccione...">-->
              <!--                </b-form-select>-->
              <!--              </b-col>-->
            </b-row>
          </b-form>
        </div>
        <hr />
        <v-server-table
          :url="url"
          :columns="columns"
          :options="options"
          :theme="theme"
          ref="table"
          id="dataTable"
        >
          <template slot="condition" slot-scope="props">
            <b-badge pill :variant="getBadge(props.row.condition)">{{
              props.row.condition
            }}</b-badge>
          </template>
          <template slot="daystay" slot-scope="props">
            <div style="text-align: right">
              <b-badge pill :variant="getDaystayBadge(props.row.daystay)">
                {{ props.row.daystay }}
              </b-badge>
            </div>
          </template>
          <template slot="afterFilter">
            <tr v-if="loading" class="VueTables__no-results">
              <b-spinner
                v-if="loading"
                variant="primary"
                class="ml-2 mt-1"
                small
                label="Small Spinner"
              ></b-spinner>
            </tr>
          </template>
          <div slot="beforeLimit">
            <download-excel
              class="btn"
              :fetch="fetchData"
              :fields="json_fields"
              worksheet="Recepcion"
              :name="name"
              :before-generate="startDownload"
              :before-finish="finishDownload"
            >
              <b-link>Descargar</b-link>
            </download-excel>
          </div>
          <template slot="child_row" scope="props">
            <div><b>Nota productor:</b> {{ props.row.note }}</div>
            <div><b>Nota interna:</b> {{ props.row.internal_note }}</div>
          </template>
          <div slot="total_kilograms" slot-scope="props">
            <div style="text-align: right">
              {{ props.row.total_kilograms.format("0,0.00") }}
            </div>
          </div>
          <div slot="total_pallets" slot-scope="props">
            <div style="text-align: right">{{ props.row.total_pallets }}</div>
          </div>
          <div slot="total_quantity" slot-scope="props">
            <div style="text-align: right">{{ props.row.total_quantity }}</div>
          </div>
          <div slot="number" slot-scope="props">
            <div style="text-align: right">{{ props.row.number }}</div>
          </div>
          <div slot="waybill_date" slot-scope="props">
            <div style="text-align: right">{{ props.row.waybill_date }}</div>
          </div>
          <div class="text-right" slot="actions" slot-scope="props">
            <a
              target="_blank"
              href="#"
              @click.prevent="getCompleteWaybill(props.row.id)"
              class="fa fa-lg fa-search text-primary"
            ></a
            >&nbsp;
            <a
              target="_blank"
              href="#"
              @click.prevent="authorizationUser(props.row, emailModal)"
              class="fa fa-lg fa-send text-primary"
            ></a
            >&nbsp;
            <a
              target="_blank"
              href="#"
              @click.prevent="downloadWithAxios(props.row.id, props.row.number)"
              class="fa fa-lg fa-file-pdf-o text-danger"
            ></a
            >&nbsp;
            <a
              target="_blank"
              href="#"
              @click.prevent="authorizationUser(props.row, editWaybill)"
              class="fa fa-lg fa-edit text-primary"
            ></a
            >&nbsp;
            <!--            <a target="_blank" @click.prevent="deleteWaybill(props.row.id)" href="#" class="fa fa-lg fa-trash text-danger"></a>-->
          </div>
        </v-server-table>
      </b-card-body>
    </b-card>

    <authorization-modal
      v-if="this.methodDynamic != null"
      :modal="Modalauthorization"
      :obj="currentObj"
      @hideAuthorizationModal="hideAuthorizationModal"
      v-on="{ methodDynamic: methodDynamic }"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import Report from "./Report.vue";
import emailModal from "../reusable/emailModal";
import authorizationModal from "../reusable/authorizationModal";

numeral.locale("es");
window.axios = require("axios");

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "DataTable",
  components: {
    ServerTable,
    emailModal,
    Report,
    authorizationModal
  },
  created() {
    this.getProducts();
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });

    this.loadYear();
  },
  data() {
    return {
      loading: false,
      to: null,
      cc: null,
      bcc: null,
      subject: null,
      msg:
        "Estimado Productor, \n" +
        "Nos es grato informarle que hemos recibido su fruta. Por favor revise en archivo adjunto los detalles de nuestra recepción.\n" +
        "\n" +
        "Atte.,",
      waybill: null,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Exportadora: "client_customer_name",
        Numero: "number",
        Productor: "company_name",
        "Fecha Guia": "waybill_date",
        Pallets: "total_pallets",
        Recip: "total_quantity",
        "Total KN": {
          field: "total_kilograms",
          callback: (value) => {
            return numeral(value).format("0.00");
          }
        },
        Nota: "note",
        "Nota Interna": "internal_note"
      },
      columns: [
        "client_customer_name",
        "waybill_date",
        "number",
        "company_name",
        "total_pallets",
        "total_quantity",
        "total_kilograms",
        "actions"
      ],
      selected: {
        product: "",
        product_type: "",
        condition: "",
        month: d.getMonth() + 1,
        year: d.getFullYear()
      },
      selectOptions: {
        products: [],
        product_types: [],
        conditions: [
          { value: "", text: "-------" },
          { value: "Orgánico", text: "Orgánico" },
          { value: "Convencional", text: "Convencional" },
          { value: "Org. System Approach", text: "Org. System Approach" },
        ],
        months: [
          { value: 1, text: "Enero" },
          { value: 2, text: "Febrero" },
          { value: 3, text: "Marzo" },
          { value: 4, text: "Abril" },
          { value: 5, text: "Mayo" },
          { value: 6, text: "Junio" },
          { value: 7, text: "Julio" },
          { value: 8, text: "Agosto" },
          { value: 9, text: "Septiembre" },
          { value: 10, text: "Octubre" },
          { value: 11, text: "Noviembre" },
          { value: 12, text: "Diciembre" }
        ],
        years: []
      },
      data: [],
      productSet: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        debounce: 800,
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            results[key].waybill_date = moment(
              results[key].waybill_date
            ).format("DD-MM-YYYY");
            results[key].total_kilograms = numeral(
              parseFloat(results[key].total_kilograms)
            );
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        // columnsDropdown: true,
        filterByColumn: false,
        headings: {
          number: "Numero",
          company_name: "Productor",
          client_customer_name: "Exportadora",
          contact_name: "Contacto",
          waybill_date: "Fecha Guia",
          actions: "Acciones",
          total_kilograms: "Kg Netos Totales",
          total_pallets: "Pallets Totales",
          total_quantity: "Cantidad Total"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      },
      Modalauthorization: false,
      currentObj: null,
      methodDynamic: null
    };
  },
  watch: {
    selected: {
      handler(val) {
        this.getProductSet(this.selected.product);
      },
      deep: true
    }
  },
  computed: {
    name() {
      return (
        "Recepciones " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls"
      );
    },
    sumMarkedKilograms() {
      let total = 0;
      // total += this.data.reduce((acc, item) => acc + item.total_kilograms.value(), 0);
      total = numeral(total);
      return total;
    },
    url() {
      return (
        "/api/v1/waybill/received_waybills/?" +
        "condition=" +
        this.selected.condition +
        "&product_type=" +
        this.selected.product_type +
        "&variety__product=" +
        this.selected.product +
        "&arrival_month=" +
        this.selected.month +
        "&arrival_year=" +
        this.selected.year
      );
    }
  },
  methods: {
    emailModal(obj) {
      this.$axios({
        method: "get",
        url: "/reports/arrival_emails/" + obj.company
      })
        .then((res) => {
          miniToastr[res.data.color](res.data.msg, "");
          this.to = res.data.emails.to.join();
          this.cc = res.data.emails.cc.join();
          this.bcc = res.data.emails.bcc.join();
        })
        .catch((error) => {});
      this.waybill_id = obj.id;
      this.subject = "Notificación de recepción G" + obj.number;
      this.$bvModal.show("email-modal");
    },
    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Guia de despacho #" + a + ".pdf"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(a, b) {
      this.$axios({
        method: "get",
        url: "/reports/arrival_pdf/" + a,
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b);
          miniToastr.success("Pdf generado con éxito.", "Mensaje:");
        })
        .catch((error) => {
          miniToastr.error("Problemas al generar pdf", "Error:");
          console.log(error);
        });
    },
    async fetchData() {
      const response = await this.$axios.get(this.url);
      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },

    getCompleteWaybill(a) {
      this.$refs.infoModal.show();
      this.$axios
        .get("/api/v1/waybill/" + a + "/waybill_complete/")
        .then((res) => {
          this.waybill = res.data;
        })
        .catch((error) => console.log(error));
    },
    getBadge(condition) {
      return condition === "Orgánico" ? "primary" : "success";
    },
    getDaystayBadge(daystay) {
      return daystay >= 10
        ? "danger"
        : daystay >= 5
        ? "warning"
        : daystay >= 3
        ? "success"
        : "primary";
    },
    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          // console.log(res)
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.selectOptions.products = products;
        })
        .catch((error) => console.log(errors));
    },
    getProductSet(a) {
      this.$axios
        .get("/production/get_product_set/" + a)
        .then((res) => {
          this.selectOptions.product_types = res.data.product_types;
        })
        .catch((error) => (this.selected.product_type = ""));
    },
    deleteWaybill(a) {
      this.$axios
        .delete("/api/v1/waybill/" + a + "/")
        .then((res) => {
          if (res.data.status == 1) {
            miniToastr.success("Guía eliminada con exito", "");
            this.$refs.table.refresh();
          }

          if (res.data.status == 2) {
            miniToastr.info(
              "Imposible eliminar la guia, tiene contenidos procesados",
              ""
            );
          }
        })
        .catch((error) => console.log(error));
    },
    editWaybill(a) {
      this.$router.push("/recepcion/editar/" + a.id);
    },
    loadYear() {
      for (let ano = 2017; ano <= d.getFullYear(); ano++) {
        this.selectOptions.years.push({ value: ano, text: ano });
      }
    },
    authorizationUser(obj, method) {
      this.currentObj = obj;
      this.Modalauthorization = true;
      this.methodDynamic = method;
    },
    hideAuthorizationModal() {
      this.Modalauthorization = false;
    }
  }
};
</script>

<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
